import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDevice } from '../../../constants/device/device';
import { ITrackShipmentEvent } from '../../../interfaces/trackShipment/trackShipmentResults';
import {
	TimelineEventDate,
	TimelineEventDescription,
	TimelineEventDot,
	TimelineEventDotWrapper,
	TimelineEventInfoWrapper,
	TimelineEventLine,
	TimelineEventLocation,
	TimelineEventRow,
	TimelineEventTitle,
	TimelineMobileEventDate,
	TimelineWrapper,
} from './trackShipmentResult.styles';

interface Props {
	events: ITrackShipmentEvent[];
}

const TrackShipmentResultTimeline: FC<Props> = ({ events }) => {
	const { t } = useTranslation('trackShipment');
	const { mobileDevice } = useDevice();

	return (
		<TimelineWrapper>
			<TimelineEventTitle content={t('shipment-events')} type="h5" />
			{events.map((event, index) => (
				<TimelineEventRow key={index}>
					{!mobileDevice && (
						<TimelineEventDate
							mobile={3 / 4}
							tablet={5 / 12}>{`${event.date} - ${event.time}`}</TimelineEventDate>
					)}
					<TimelineEventDotWrapper mobile={1 / 6}>
						<TimelineEventDot />
						{index < events.length - 1 && <TimelineEventLine />}
					</TimelineEventDotWrapper>
					<TimelineEventInfoWrapper mobile={5 / 6} tablet={5 / 12}>
						{mobileDevice && (
							<TimelineMobileEventDate>{`${event.date} - ${event.time}`}</TimelineMobileEventDate>
						)}
						<TimelineEventDescription>{event.description}</TimelineEventDescription>
						<TimelineEventLocation>{event.location}</TimelineEventLocation>
					</TimelineEventInfoWrapper>
				</TimelineEventRow>
			))}
		</TimelineWrapper>
	);
};

export default TrackShipmentResultTimeline;
